import React from 'react';
import './PracticeAreas.css';

const practiceAreas = [
    {
        label: "Consumer Disputes",
        image: "/images/consumer.webp",
        description: "We help consumers fight against unfair business practices, fraudulent charges, and deceptive sales tactics. From unauthorized transactions to warranty disputes, we ensure your rights are protected."
    },
    {
        label: "Employment Law",
        image: "/images/employment.webp",
        description: "We represent employees in cases of workplace harassment, discrimination, wrongful termination, wage theft, and retaliation. Your workplace rights matter, and we fight to protect them."
    },
    {
        label: "Business Litigation",
        image: "/images/business.webp",
        description: "We handle complex business disputes including breach of contract, partnership disputes, and commercial litigation. Our experienced team protects your business interests."
    },
    {
        label: "Unauthorized Transactions",
        image: "/images/debit.webp",
        description: "If you have been charged for services you didn't authorize or subscriptions you can't cancel, we can pursue recovery of your funds and stop future unauthorized charges."
    },
    {
        label: "Breach of Contract",
        image: "/images/contract.webp",
        description: "When contracts are broken, we help you understand your rights and pursue remedies. From service agreements to major business contracts, we protect your interests."
    },
    {
        label: "Privacy Law",
        image: "/images/privacy.webp",
        description: "We help clients navigate privacy violations, data breaches, and illegal surveillance. Your personal information deserves protection under the law."
    },
    {
        label: "Unfair Debt Collection",
        image: "/images/debt1.jpeg",
        description: "We fight against unfair debt collection practices, including harassment and deceptive tactics. Let us help you reclaim your rights."
    },
    {
        label: "Civil Appeals",
        image: "/images/civil-appeals.webp",
        description: "When trial court decisions need review, our appellate experience helps present your case effectively to higher courts for potential reversal or modification."
    }

];

function PracticeAreas() {
    return (
        <div className="practice-areas-container">
            <section className="section practice-areas-header-section">
                <h1>Our Practice Areas</h1>
                <p>We specialize in protecting individuals and businesses from unfair practices across multiple areas of law.</p>
            </section>

            <div className="practice-areas-list">
                {practiceAreas.map((area, index) => (
                    <div 
                        key={index} 
                        className={`practice-area-item ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
                    >
                        <div className="practice-area-image">
                            <img 
                                src={area.image} 
                                alt={area.label}
                                loading="lazy"
                            />
                        </div>
                        <div className="practice-area-content">
                            <h2>{area.label}</h2>
                            <p>{area.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PracticeAreas;